import React, { ReactElement } from 'react';
import CatalogItem from './catalog-item';
import { CourseCatalog, RemoteOrganizer } from '../types';
import SearchFilter from './search-filter';
import KretsFilter from './krets-filter';
import { SelectedKrets } from './krets-actions';

interface Props {
  title?: string;
  catalog: CourseCatalog[];
  organizers: RemoteOrganizer[];
  selectedKretsar: SelectedKrets[];
  organizationId?: string;
  searchFilterText: string;
}

export default function Catalog({ title = 'Katalog', catalog, organizers, organizationId, searchFilterText = '' }: Props): ReactElement {
  const mappedCatalog = catalog.map((c) => (
    <CatalogItem
      key={c.title}
      title={c.title}
      index={c.index}
      types={c.types}
      activities={c.activities}
      organizers={organizers}
      searchFilterText={searchFilterText}
    />
  ));
  return (
    <div className="sxk-course-catalog-component">
      <div>
        <div className="ts-activity-item-title page-title-box">
          <div className="ts-activity-item-title-wrap page-title-box-inner content-bg">
            <h1>{title}</h1>
          </div>
        </div>
        <div className="filter-area">
          <SearchFilter />
          <KretsFilter organizationId={organizationId} />
        </div>
        <div className="exp-menu">
          <div className="menu">
            <ul>{mappedCatalog}</ul>
          </div>
        </div>
      </div>
    </div>
  );
}
Catalog.displayName = 'Catalog';
